var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_c('span',[_vm._v(_vm._s(_vm.data[_vm.title]))])]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.data[_vm.description]))])])}
var staticRenderFns = []

export { render, staticRenderFns }